var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltipS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.125 13.125C10.5077 13.125 13.25 10.3827 13.25 7C13.25 3.61726 10.5077 0.875 7.125 0.875C3.74226 0.875 1 3.61726 1 7C1 10.3827 3.74226 13.125 7.125 13.125Z",
    stroke: "#002855",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.125 5.7749V10.2666",
    stroke: "#002855",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.1252 4.14175C7.46347 4.14175 7.7377 3.86752 7.7377 3.52925C7.7377 3.19097 7.46347 2.91675 7.1252 2.91675C6.78692 2.91675 6.5127 3.19097 6.5127 3.52925C6.5127 3.86752 6.78692 4.14175 7.1252 4.14175Z",
    fill: "#002855"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipS);
export default __webpack_public_path__ + "static/media/tooltip-s.1e7c9684f35729264a292f3fecb2f5e0.svg";
export { ForwardRef as ReactComponent };